import { useState } from "react"
import avatar from "../../assets/images/avatar.png"
import { addNewFriend } from "../../utils/helper"
import { useAuth } from "../../contexts/AuthContext"

const checkIfItsAFriend = (friendsArray, otherUserId) => {
  let friends = false
  friendsArray.forEach((friend) => {
    if (friend.id === otherUserId) {
      friends = true
    }
  })
  return friends
}

const OtherUserCard = ({ otherUser, friends, setSearchString }) => {
  const { currentUser } = useAuth();
  const [addedFriend, setAddedFriend] = useState(
    checkIfItsAFriend(friends, otherUser.id)
  )

  const handleAddFriend = (e) => {
    e.preventDefault();
    addNewFriend(currentUser.user.uid, otherUser.id);
    setAddedFriend(true);
    setSearchString('')
  };

  return (
    <div id={otherUser.id} className="userCard" >
      <img alt="" src={otherUser.data()?.image ?? avatar} className="rounded-full w-32" />
      <h2 className="font-bold mt-3">{otherUser.data().pseudo}</h2>
      {addedFriend ? (
        <p>{otherUser.data().pseudo} est votre ami</p>
      ) : (
        <button className="friendsButtonStyle gradient" onClick={handleAddFriend} >
          Ajouter
        </button>
      )}
    </div>
  )
}

export default OtherUserCard
